import { render, staticRenderFns } from "./VPortfolio.vue?vue&type=template&id=3a135063&"
import script from "./VPortfolio.vue?vue&type=script&lang=js&"
export * from "./VPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./VPortfolio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports